export default "__VITE_ASSET__DZYTRg1___"